import { render, staticRenderFns } from "./ScriptAdd.vue?vue&type=template&id=a0f761d2&scoped=true"
import script from "./ScriptAdd.vue?vue&type=script&lang=js"
export * from "./ScriptAdd.vue?vue&type=script&lang=js"
import style0 from "./ScriptAdd.vue?vue&type=style&index=0&id=a0f761d2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0f761d2",
  null
  
)

export default component.exports